import { Injectable } from '@angular/core';
import { AvailabilityAPIService } from '../../shared/services/API/AvailabilityAPI.service';
import { AvailabilityDTO } from '../models/AvailabilityDTO';
@Injectable({
    providedIn: 'root'
  })

export class AvailabilityService{

  constructor(
    private availbailityService: AvailabilityAPIService){
  }

  InsertRange(availabilityList: AvailabilityDTO[]):any{
    return this.availbailityService.InsertRange(availabilityList);
  }

  GetListAvailabilityFilterByLocationCategory(filtersRequest : any[], initialDate: string, finalDate: string, idLocationCategories: number[]): any {
     return this.availbailityService.GetListAvailabilityFilterByLocationCategory(filtersRequest, initialDate, finalDate, idLocationCategories);
  }
}
